var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',_vm._g(_vm._b({attrs:{"value":_vm.value,"length":_vm.length},on:{"input":_vm.on_input}},'v-pagination',_vm.$attrs,false),_vm.unhandled_events),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }